







import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import StaffEdit from "@/templates/StaffEdit.vue";
import SaveStaffRequest from "@/usecases/requests/save-staff-request";
import { Company, Office, getOtherCompanies } from "@/api/company-api";
import { getServiceRoles } from "@/api/service-api";
import Role from "@/entities/role";
import TaskType from "@/entities/task-type";

@Component({
  components: {
    StaffEdit
  }
})
export default class CompanyStaffNewPage extends Vue {
  @Prop({ required: true }) companyId!: string;

  req = new SaveStaffRequest();
  companies: Company[] = [];
  roles: Role[] = [];
  errors: string[] = [];

  get tasktypes(): TaskType[] {
    return this.$store.getters["tasktype/all"];
  }

  ok() {
    this.save();
  }

  cancel() {
    this.goShowPage();
  }

  private company: Company | null = null;
  private office: Office | null = null;

  private async created() {
    this.$store.dispatch("tasktype/init");
    await this.initCompanies();
    this.initServiceRoles();
    this.initStaff();
    this.req.hasRole = true;
    this.req.isWorker = true;
  }

  private async initServiceRoles() {
    this.roles = await getServiceRoles();
  }

  private async initCompanies() {
    this.companies = await getOtherCompanies();
    this.selectCompany();
  }

  @Watch("companyId")
  private selectCompany() {
    const c = this.companies.find(c => String(c.companyId) === this.companyId);
    if (c) {
      this.company = { ...c };
      this.office = { ...c.office };
    } else {
      this.company = null;
      this.office = null;
    }
  }

  private initStaff() {
    this.req.officeId = this.office ? this.office.officeId : 0;
  }

  private async save() {
    try {
      await this.$store.dispatch("saveStaff", this.req);
      this.goShowPage();
    } catch (e) {
      this.errors = e as [];
      return false;
    }
  }

  private goShowPage() {
    const params = { id: this.companyId };
    this.$router.push({ name: "companies-show", params });
  }
}
